import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';

import Ionicons from '@react-native-vector-icons/ionicons';
import iconFont from '@react-native-vector-icons/ionicons/fonts/Ionicons.ttf';

import { App } from './src/App';

// the following is required to load Ionicons for react-native-vector-icons
const iconFontStyles = `@font-face {
  src: url(${iconFont});
  font-family: Ionicons;
}`;

const style = document.createElement('style');

style.type = 'text/css';

if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}

document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));

const tagManagerArgs = { gtmId: 'GTM-5SVM4PBK' };
TagManager.initialize(tagManagerArgs);

root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <App />
    </LocalizationProvider>
  </React.StrictMode>,
);
